import { useSprintMutation, useSprintQueryClient } from "sprint-common-web";

import { RequestWaitingForClientResponseRequest } from "../../../../common/api/master-api/cloud-files/request-waiting-for-client-response/RequestWaitingForClientResponseRequest";
import { useCloudFileApi } from "../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { FileRecordQueryKey } from "../../../common/file-record-details/FileRecordQueryKey";
import { CloudFileQueryKey } from "../common/CloudFileQueryKey";

export const useRequestWaitingForClientResponse = ({
    cloudFileId,
    fileRecordId
}: {
    cloudFileId?: string;
    fileRecordId?: string;
}) => {
    const cloudFileApi = useCloudFileApi();
    const sprintQueryClient = useSprintQueryClient();

    const requestWaitingForClientResponse = useSprintMutation<RequestWaitingForClientResponseRequest>({
        mutationFn: async (request: RequestWaitingForClientResponseRequest) => {
            return cloudFileApi.requestFilesWaitingForClientResponse(request);
        },
        onSettled: async () => {
            if (cloudFileId) {
                await sprintQueryClient.invalidateQueries({
                    queryKey: [CloudFileQueryKey.CloudFileDetails, cloudFileId]
                });
            }
            if (fileRecordId) {
                await sprintQueryClient.invalidateQueries({
                    queryKey: [FileRecordQueryKey.FileRecordDetails, fileRecordId]
                });
            }
        }
    });

    return {
        requestWaitingForClientResponse
    };
};
